import { Card, Tooltip } from "@material-ui/core";
import clsx from "clsx";
import { theme } from "config/theme";
import { COLORS } from "constants/colors";
import React from "react";
import styled from "styled-components";

export interface ParcelCardProps {
  disabled?: boolean;
  icon: React.ReactElement;
  title: string;
  value: React.ReactNode;
}
const Wrapper = styled(Card)`
  border-radius: 5px;
  box-shadow: none;
  display: flex;
  height: 64px;
  position: relative;
  width: 100%;
  background-color: #e2f4fb;

  &.disabled::after {
    background-color: #fff;
    bottom: 0;
    content: "";
    opacity: 0.5;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

const Icon = styled.div`
  align-items: center;
  background-color: ${COLORS.primary};
  display: flex;
  height: 64px;
  justify-content: center;
  width: 74px;
`;

const Content = styled.div`
  border-radius: 5px;
  color: #707070;
  display: flex;
  height: 64px;
  padding: 5px;
  align-items: center;
  width: 90%;
  fonsize: 14px;
  flex-direction: column;
  font-weight: 500;
  justify-content: center;
  align-items: flex-start;
  ${theme.breakpoints.down("xs")} {
    align-items: inherit;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #757a93;
  }
  .title {
    color: ${COLORS.primary};
    margin-right: 5px;
    font-weight: bold;
    font-size: 14px;

    ${theme.breakpoints.down("xs")} {
      color: ${COLORS.primary};
      margin-right: 5px;
      font-weight: bold;
      font-size: 14px;
      align-items: inherit;
      text-align: left;
    }
  }

  .value {
    font-size: 10px;
  }
`;

function ParcelCard({ title, value, icon, disabled }: ParcelCardProps) {
  const { props }: any = value || {};
  const [lang, setLang] = React.useState(null);

  React.useEffect(() => {
    setLang(window.localStorage.getItem("i18nextLng"));
  }, [value, lang]);
  const renderReccurenceWeek = React.useCallback(
    () =>
      lang === "en"
        ? props?.children?.props?.children[0].slice(0, 21)
        : props?.children?.props?.children[0].slice(0, 28),
    [value, lang]
  );

  return (
    <Wrapper className={clsx({ disabled })}>
      <Icon>{icon}</Icon>
      <Content>
        <span className="title">{title} :</span>
        <Tooltip title={value}>
          <div>
            <span className="value">
              {renderReccurenceWeek() || `${value?.toString()?.substring(0,18)}...`}              
            </span>
          </div>
        </Tooltip>
      </Content>
    </Wrapper>
  );
}

export default ParcelCard;
